import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { OptimizationRecommendationsType, ViguideRecommendations } from '@vi-iot/client';

import { ViguideRecommendationActions } from './viguide-recommendations.actions';
import { OptimizationRecommendationSlug } from './viguide-recommendations.model';
import { ViguideRecommendationsSelectors } from './viguide-recommendations.selectors';

@Injectable({ providedIn: 'root' })
export class ViguideRecommendationsStore {
  constructor(public store: Store) {}

  shouldFetchOptimizationRecommendations$ = this.store.select(
    ViguideRecommendationsSelectors.shouldFetchOptimizationRecommendations
  );

  isAnyOptimizationRecommendationAvailable$ = this.store.select(
    ViguideRecommendationsSelectors.isAnyOptimizationRecommendationAvailable
  );
  optimizationRecommendations$ = this.store.select(
    ViguideRecommendationsSelectors.getOptimizationRecommendations
  );
  installationsWithRecommendations$ = this.store.select(
    ViguideRecommendationsSelectors.installationsWithRecommendations
  );

  fetchBoilerOptimizationsRecommendations(): void {
    this.store.dispatch(ViguideRecommendationActions.getOptimizationRecommendationsAttempt());
  }

  getOptimizationRecommendations(): Observable<ViguideRecommendations[]> {
    return this.store.select(ViguideRecommendationsSelectors.getOptimizationRecommendations);
  }

  getAvailableRecommendationsForTile(
    expectedRecommendations: OptimizationRecommendationsType[],
    ignoredTileName: OptimizationRecommendationSlug
  ): Observable<OptimizationRecommendationsType[]> {
    return this.store.select(
      ViguideRecommendationsSelectors.getAvailableRecommendationsForTile(
        expectedRecommendations,
        ignoredTileName
      )
    );
  }

  closeRecommendationTile(tileName: OptimizationRecommendationSlug): void {
    this.store.dispatch(ViguideRecommendationActions.closeRecommendationTile({ tileName }));
  }

  fetchProInstallations(): void {
    this.store.dispatch(ViguideRecommendationActions.fetchProInstallations.attempt());
  }
}
